import { axiosInstance } from '../api';


export default function () {
    return axiosInstance.get(`/api/app_admin/app_config`);
}